import React, { useState } from 'react';
import { CALL_API, successResponse, notSuccessResponse } from '../../../util/api'

export const menuSearchApi = async (param) => {

    try {
        const response = await CALL_API.post('Menu/Search', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

export const menuInsertApi = async (param) => {

    try {
        const response = await CALL_API.post('Menu/Insert', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const menuUpdateApi = async (param) => {

    try {
        const response = await CALL_API.post('Menu/Update', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
export const menuUpdateStatusApi = async (param) => {

    try {
        const response = await CALL_API.post('Menu/UpdateStatus', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


export const menuLookupApi = async () => {

    try {
        const response = await CALL_API.post('Menu/Lookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}